import { FC } from 'react'
import { Box, Stack, Link, Typography, Divider } from '@mui/material'
import { Link as RouterLink } from 'react-router-dom'

/**
 * Versão em execução: a tag da imagem do frontend, gravada no bundle pelo build
 * (`VITE_APP_VERSION`, vindo do `-Tag` do scripts/docker-build-push.ps1). Sem ela, "dev".
 */
export const versaoDoSistema = (valor = import.meta.env.VITE_APP_VERSION): string =>
  valor?.trim() || 'dev'

/**
 * Footer global com links LGPD obrigatórios — visível em todas as telas autenticadas
 * e nas páginas públicas (login, privacidade, termos, dpo).
 */
export const AppFooter: FC = () => {
  return (
    <Box
      component="footer"
      sx={{
        py: 2,
        px: 3,
        mt: 'auto',
        borderTop: '1px solid',
        borderColor: 'divider',
        bgcolor: 'background.paper',
      }}
    >
      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        spacing={1.5}
        alignItems="center"
        justifyContent="space-between"
      >
        <Typography variant="caption" color="text.secondary">
          © {new Date().getFullYear()} Originei. Todos os direitos reservados. · Versão {versaoDoSistema()}
        </Typography>
        <Stack
          direction="row"
          spacing={1.5}
          alignItems="center"
          divider={<Divider orientation="vertical" flexItem />}
        >
          <Link
            component={RouterLink}
            to="/privacidade"
            variant="caption"
            color="text.secondary"
            underline="hover"
          >
            Privacidade
          </Link>
          <Link
            component={RouterLink}
            to="/termos"
            variant="caption"
            color="text.secondary"
            underline="hover"
          >
            Termos
          </Link>
          <Link
            component={RouterLink}
            to="/dpo"
            variant="caption"
            color="text.secondary"
            underline="hover"
          >
            DPO
          </Link>
          <Link
            component={RouterLink}
            to="/lgpd/ropa"
            variant="caption"
            color="text.secondary"
            underline="hover"
          >
            ROPA
          </Link>
        </Stack>
      </Stack>
    </Box>
  )
}
